/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Side
 */
export type GetExchangesResponseSide = typeof GetExchangesResponseSide[keyof typeof GetExchangesResponseSide];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExchangesResponseSide = {
  buy: 'buy',
  sell: 'sell',
} as const;
